export function createRealtimeClient({
  serverUrl,
  roomCode,
  playerName,
  onOpen,
  onClose,
  onError,
  onMessage
}) {
  const ws = new WebSocket(serverUrl)

  ws.onopen = () => {
    ws.send(
      JSON.stringify({
        type: 'join',
        roomCode,
        playerName
      })
    )
    onOpen?.()
  }

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data)
      onMessage?.(data)
    } catch (error) {
      onError?.(error)
    }
  }

  ws.onerror = (event) => {
    onError?.(new Error(event?.message || 'WS_ERROR'))
  }

  ws.onclose = () => {
    onClose?.()
  }

  return {
    send(payload) {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(payload))
      }
    },
    close() {
      ws.close()
    }
  }
}
